import styles from './Skeleton.module.css'

export interface SkeletonProps {
  readonly variant?: 'text' | 'row'
  /** Repeat count — a table placeholder wants rows, not one tall block. */
  readonly count?: number
  /** Describes what is loading, for assistive tech. The visual shimmer is
   *  decorative; without this the region is announced as empty. */
  readonly label: string
}

/**
 * The brief is explicit that skeletons replace spinners: BigQuery answers in
 * 1-3s and a spinner over a blank screen for that long reads as broken.
 *
 * `aria-busy` plus a single `role="status"` label means a screen reader says
 * "loading transactions" once, rather than announcing every shimmering row.
 */
export function Skeleton({ variant = 'text', count = 1, label }: SkeletonProps) {
  return (
    <div role="status" aria-busy="true" aria-live="polite">
      <span className="sr-only">{label}</span>
      {Array.from({ length: count }, (_, i) => (
        <span key={i} className={[styles.skeleton, styles[variant]].filter(Boolean).join(' ')} aria-hidden="true" />
      ))}
    </div>
  )
}
